// src/redux/sagas/menuItemDetailsSaga.ts
import { call, put, takeEvery,select} from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { request } from '../../api/request';
import { RootState } from '../store';
import ENDPOINTS from '../../api/endpoints';
import {
  fetchMenuItemDetailsRequest,
  fetchMenuItemDetailsSuccess,
  fetchMenuItemDetailsFailure,
} from '../slices/menuItemDetailsSlice';
// import { RootState } from '../store';

// API Response interface
interface MenuItemDetailsApiResponse {
  success: boolean;
  message: string;
  data: {
    items: any[];
    categories: any[];
    modifiers: any[];
  };
  error: null;
}

function* fetchMenuItemDetailsSaga(action: PayloadAction<string>): any {
  try {
    const itemId = action.payload;
    
    // Get selected restaurant from Redux state
    // const selectedRestaurant = yield select((state: RootState) => state.restaurant.selectedRestaurant);
    const restaurantId = '7cdb36d9-c51b-473e-9a9f-cfc468ee6d0b'
    // selectedRestaurant?.restaurant_id;
    
    if (!restaurantId) {
      throw new Error('Restaurant ID is required');
    }
    
    // Call API directly
    const response = yield call(request<MenuItemDetailsApiResponse>, {
      method: 'GET',
      url: `${ENDPOINTS.MENU_ITEM_DETAILS_API_PATH}/${itemId}`,
      base: ENDPOINTS.API_V2_BASE_URL,
      headers: {
        'restaurant-id': restaurantId,
      },
      requiresAuth: false,
      requiresRestaurantId: false,
    });

    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to fetch menu item details');
    }
    
    yield put(fetchMenuItemDetailsSuccess(response.data.data));
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to fetch menu item details';
    yield put(fetchMenuItemDetailsFailure(errorMessage));
  }
}

export function* watchMenuItemDetailsSaga() {
  yield takeEvery(fetchMenuItemDetailsRequest.type, fetchMenuItemDetailsSaga);
}
